import * as i0 from "@angular/core";
const _c0 = ["*"];
export let UiContainerComponent = /*#__PURE__*/(() => {
  class UiContainerComponent {
    constructor() {
      this.enable = true;
      this.wide = false;
      this.padded = true;
      this.paddedVertically = false;
    }
    set _enabled(value) {
      // as value is omitted in most cases, we only want an explicit "false" to disable the styling!
      this.enable = value !== false;
    }
    static {
      this.ɵfac = function UiContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiContainerComponent,
        selectors: [["ui-container"], ["", "uiContainer", ""]],
        hostVars: 8,
        hostBindings: function UiContainerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ui-container", ctx.enable)("wide", ctx.wide)("padded", ctx.padded)("padded-vert", ctx.paddedVertically);
          }
        },
        inputs: {
          _enabled: [0, "uiContainer", "_enabled"],
          wide: [0, "uiContainerWide", "wide"],
          padded: "padded",
          paddedVertically: "paddedVertically"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function UiContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: [".ui-container[_nghost-%COMP%]{display:block;margin:0 auto;position:relative;width:960px;padding:0;max-width:100%;box-sizing:border-box}@media (min-width: 1280px){.ui-container[_nghost-%COMP%]{width:1220px;padding:0 30px}}.ui-container.wide[_nghost-%COMP%]{width:auto}.ui-container.padded[_nghost-%COMP%]{padding:0 20px}.ui-container.padded-vert[_nghost-%COMP%]{padding-top:20px;padding-bottom:20px}"],
        changeDetection: 0
      });
    }
  }
  return UiContainerComponent;
})();